import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import { observer } from 'mobx-react'
import CardDetalhe from '../../../../comum/components/CardDetalhe'

@observer
export default class DetalhesOrcamentoExport extends Component {
    
    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }
    
    render() {
        return (
            <Col className="container-card-detalhe">
                <Row className="m-0 no-gutters">
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CardDetalhe
                            titulo="Despachante"
                            desc={[this.props.row.Despachante]}
                        />
                    </Col>        
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CardDetalhe
                            titulo="Cliente"
                            desc={[this.props.row.Cliente]}
                        />
                    </Col>        
                </Row>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/components/DetalhesOrcamentoExport.js